<script>
// Extensions
import { BaseItemGroup } from "@/components/ui/app/AppItemGroup";
import SSRBootable from "@mixins/ssr-bootable";
import mixins from "@/core/util/mixins";

export default mixins(BaseItemGroup, SSRBootable).extend({
  name: "TabsBar",

  provide() {
    return {
      tabsBar: this
    };
  },

  computed: {
    classes() {
      return {
        ...BaseItemGroup.options.computed.classes.call(this),
        "tabs-bar": true
      };
    }
  },

  watch: {
    items: "callSlider",
    internalValue: "callSlider",
    $route: "onRouteChange"
  },

  methods: {
    callSlider() {
      if (!this.isBooted) return;

      this.$emit("call:slider");
    },
    onRouteChange(val, oldVal) {
      /* istanbul ignore next */
      if (this.mandatory) return;

      const items = this.items;
      const newPath = val.path;
      const oldPath = oldVal.path;

      let hasNew = false;
      let hasOld = false;

      for (const item of items) {
        if (item.to === newPath) hasNew = true;
        else if (item.to === oldPath) hasOld = true;

        if (hasNew && hasOld) break;
      }

      // If we have an old item and not a new one
      // it's assumed that the user navigated to
      // a path that is not present in the items
      if (!hasNew && hasOld) this.internalValue = undefined;
    }
  }
});
</script>

<style lang="scss">
.tabs-bar {
  display: flex;
  min-width: 0;
  height: 60px;

  @include breakpoint("xs-only") {
    height: 45px;
  }
}
</style>
